import React, { forwardRef } from 'react';

import MUITableBody, {
  TableBodyProps as MUITableBodyProps,
} from '@material-ui/core/TableBody';

export interface TableBodyProps extends MUITableBodyProps {}

const TableBody = forwardRef<HTMLTableSectionElement, TableBodyProps>(
  (props, ref) => {
    return <MUITableBody {...props} ref={ref} />;
  }
);

export default TableBody;
